import { Component, computed, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '@via/services';
import { Sidebar } from 'primeng/sidebar';

import { SidebarService } from './sidebar.service';

@Component({
  selector: 'via-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  @ViewChild('sidebarRef') sidebarRef!: Sidebar;
  isSidebarOpen = computed(() => this.sidebarService.isOpen());
  isSidebarAlwaysOpen = computed(() => this.sidebarService.isAlwaysOpen());

  constructor(
    public commonService: CommonService,
    private router: Router,
    public sidebarService: SidebarService
  ) {}

  changeSideBarPreference = (event: { checked: boolean }) => {
    this.sidebarService.togglePreference(event?.checked);
  };

  closeCallback(e: any, isCloseIcon = false): void {
    if (isCloseIcon || !this.isSidebarAlwaysOpen())
      this.sidebarService.toggle();

    if (isCloseIcon) {
      this.sidebarService.togglePreference(false);
    }
  }

  gotoDashboard() {
    this.router.navigate(['/']);
  }
}
